import { UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_FAILURE_DK, UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_SUCCESS_DK } from "../billEntries/billEntries.actionType";
import { BILL_ENTRY_DETAIL_USERFORM_RESET, CREATE_SET_EDIT_ENTRIES_GRID_DATA, CREATE_USER_FORM_EDIT_BILL_ENTRIES_DK, DELETE_EDIT_BTN_UPDATE_API_FAILURE, DELETE_EDIT_BTN_UPDATE_API_REQUEST, DELETE_EDIT_BTN_UPDATE_API_SUCCESS, EDIT_BILL_ENTRY_DETAIL_USERFORM_RESET, FETCH_EDIT_BILL_ENTRIES_FORM_FAILURE_DK, FETCH_EDIT_BILL_ENTRIES_FORM_REQUEST_DK, FETCH_EDIT_BILL_ENTRIES_FORM_SUCCESS_DK, FETCH_EDIT_BILL_ENTRIES_REPORT_FAILURE_DK, FETCH_EDIT_BILL_ENTRIES_REPORT_REQUEST_DK, FETCH_EDIT_BILL_ENTRIES_REPORT_SUCCESS_DK, FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_FAILURE_DK, FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_REQUEST_DK, FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_SUCCESS_DK, FETCH_EDIT_BILL_ENTRY_BRN_NO_FAILURE, FETCH_EDIT_BILL_ENTRY_BRN_NO_REQUEST, FETCH_EDIT_BILL_ENTRY_BRN_NO_SUCCESS, FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_FAILURE_DK, FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_REQUEST_DK, FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_SUCCESS_DK, SET_EDIT_ENTRIES_GRID_DATA, UPDATE_EDIT_BILL_ENTRY_DETAILS_FAILURE_DK, UPDATE_EDIT_BILL_ENTRY_DETAILS_ID_REQUEST_DK, UPDATE_EDIT_BILL_ENTRY_DETAILS_REQUEST_DK, UPDATE_EDIT_BILL_ENTRY_DETAILS_SUCCESS_DK, UPDATE_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_REQUEST_DK, UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_FAILURE_DK, UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_REQUEST_DK, UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_SUCCESS_DK, UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_FAILURE_DK, UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_REQUEST_DK, UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_SUCCESS_DK } from "./editentries.actionType";

export const EDIT_ENTRIES = 'billentries';

let initialState = {
    loading: false,
    // reportProgramWiseList: [],
    // reportCuttingWiseList: [],
    // reportSingleProgramInwardList: [],
    EditEntry: [],
    EditFormInputData: {

    },
    EditFormInputTableData: [],
    editentryGriddata: [],
    formDetailsId: '',
    editedentryDetailId: '',
    gridDetailsId: '',
    editBrnNo: ''
    // userform:{
    //     fldFKSupplier: '',
    //     fldGrandTotalValue: 0,
    //     fldRoundoff: 0,
    // }
    // CompletedGrid: [],
    // CancelledGrid: [],
    // renderGridBtn: 'summaryGrid'
    //renderGridBtn: 'detailGrid',

};

export let editEntriesReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_EDIT_BILL_ENTRIES_REPORT_REQUEST_DK:
        case FETCH_EDIT_BILL_ENTRIES_FORM_REQUEST_DK:
        case FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_REQUEST_DK:
        case UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_REQUEST_DK:
        case UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_SUCCESS_DK:
        case UPDATE_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_REQUEST_DK:
        case FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_REQUEST_DK:
        case DELETE_EDIT_BTN_UPDATE_API_REQUEST:
        case UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_REQUEST_DK:
        case FETCH_EDIT_BILL_ENTRY_BRN_NO_REQUEST:
            return {
                ...state,
                loading: true
            };

        case FETCH_EDIT_BILL_ENTRIES_REPORT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                EditEntry: updatePayload
            };
        case FETCH_EDIT_BILL_ENTRIES_FORM_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                EditFormInputData: updatePayload
            };
        case FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                EditFormInputTableData: updatePayload?.BED,
                editentryGriddata: updatePayload?.BED
            };
        case UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                formDetailsId: updatePayload
            }
        case UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                gridDetailsId: updatePayload
            }
        case UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                editedentryDetailId: updatePayload
            }
        case DELETE_EDIT_BTN_UPDATE_API_SUCCESS:
            return {
                ...state,
                loading: false,
                editCalloff: updatePayload
            }
        case CREATE_USER_FORM_EDIT_BILL_ENTRIES_DK:
            return {
                ...state,
                loading: false,
                EditFormInputData: {
                    ...state.EditFormInputData,
                    [payload.key]: payload.value
                }
            };
        case CREATE_SET_EDIT_ENTRIES_GRID_DATA:
            return {
                ...state,
                loading: false,
                editentryGriddata: payload
            };
        case FETCH_EDIT_BILL_ENTRY_BRN_NO_SUCCESS:
            return {
                ...state,
                loading: false,
                editBrnNo: updatePayload
            };
        case FETCH_EDIT_BILL_ENTRIES_REPORT_FAILURE_DK:
        case FETCH_EDIT_BILL_ENTRIES_FORM_FAILURE_DK:
        case FETCH_EDIT_BILL_ENTRIES_TABLE_DATA_FAILURE_DK:
        case UPDATE_EDIT_BILL_ENTRY_FORM_DETAILS_FAILURE_DK:
        case UPDATE_VERIFY_BILL_ENTRY_DETAILS_ID_FAILURE_DK:
        case FETCH_EDIT_BILL_ENTRY_DETAILS_TABLE_ID_FAILURE_DK:
        case DELETE_EDIT_BTN_UPDATE_API_FAILURE:
        case UPDATE_EDIT_BILL_ENTRY_GRID_DETAILS_FAILURE_DK:
        case FETCH_EDIT_BILL_ENTRY_BRN_NO_FAILURE:
            return {
                ...state,
                loading: false,
                editBrnNo: ''
            };
        case SET_EDIT_ENTRIES_GRID_DATA:
            return {
                ...state,
                loading: false,
                editentryGriddata: payload
            };
        case EDIT_BILL_ENTRY_DETAIL_USERFORM_RESET:
            return {
                ...state,
                loading: false,
                EditFormInputData: {
                    // fldProgramName: '',
                    // fldSupplierName: '',
                    // fldBENo: '',
                    // fldPreparedBy: '',
                    // fldInvoiceNo: 0,

                },
                EditFormInputTableData: [],
                formDetailsId: ''
            }
        default:
            return state;
    }
};